export default "__VITE_ASSET__b5697947__"